<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :selectComId="selectComId" :showIncludeSubComs="true" :initIncludeSubComs="includeSubComs" :bizDepart="true" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btns">
            <!-- 关闭-手工配货(任务) 2021-01-28 @cui -->
            <!--<div class="left">-->
            <!--<div class="swb-btn swb-btn-small mr5" @click="saveAllocFrom(null)">-->
            <!--<span>新增配货单</span>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="right">-->
            <!--<span class="mr10">批量配货导入</span>-->
            <!--<swb-file-upload class="inline-block" style="top: 8px;" fileGroup="goods.order.alloc.import" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>-->
            <!--<a class="swb-btn swb-btn-link" @click="showImportElpx">导入说明</a>-->
            <!--<a class="swb-btn-link" @click="downloadAllocFromTemplate">下载配货模板</a>-->
            <!--</div>-->
        </div>
        <div name="tabs-block">
            <el-tabs v-model="orderFlag" @tab-click="handleClick">
                <el-tab-pane label="订单" name="true"></el-tab-pane>
                <el-tab-pane label="非订单" name="false"></el-tab-pane>
            </el-tabs>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="resultKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf';
    import { checkUserActionPerm } from '../index'
    import { showAllocFormTemplateDialog, openAllocFormImpCheckDlg, openAllocFormFormatExplDlg } from './dialog'

    import goodsOrderApi from '../../api/goodsOrder'
    import userApi from '../../api/user'

    import SwbOrderGoodsAllocFormSave from './OrderGoodsAllocFormSave'
    Routes.add(SwbOrderGoodsAllocFormSave);

    import SwbOrderGoodsAllocFormDetail from './OrderGoodsAllocFormDetail'
    Vue.regist(SwbOrderGoodsAllocFormDetail);

    import SwbOrderGoodsAllocItemList from './OrderGoodsAllocItemList';
    Vue.regist(SwbOrderGoodsAllocItemList);

    import SwbShowGoodsOrder from './ShowGoodsOrder'
    Routes.add(SwbShowGoodsOrder);
    //
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    //
    export default {
        name: 'swb-order-goods-alloc-form-list',
        path: '/order/goods/alloc/form/list',
        avlActions: '',
        avlScopes: 'retailer',
        authen: false,
        desc: '配货单列表',
        data: function () {
            return {
                confKey: "swb-order-goods-alloc-form-list",
                resultKey: "swb-order-goods-alloc-form-list",
                queryOnLoad: true,
                tableHeight: 300,
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 150,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                comLevel: null,
                selectComId: null,
                includeSubComs: true,
                allocFormStateMap: {},
                orderFlag: "false",
                file: {},
                mgmtSmlAreaId: null,
                scopeEntity: null
            }
        },
        created: function () {
            this.allocFormStateMap = getEnumMap('allocFormState', 'value2text');
            this.getCurrUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name = "result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
                console.log("qw" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout,[name="query-sort-block"],.simple-row,[name="tabs-block"]'));
            domSizeWatcher.start(500);
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrUserInfo() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        self.selectComId = result.data.scopeEntity.comId;
                        self.scopeEntity = result.data.scopeEntity;
                    }
                });
            },
            onConfigReady: function () {
                let allocFormStateList = getEnumList("allocFormState");
                let dataList = [];
                if(allocFormStateList != null && allocFormStateList.length > 0) {
                    dataList.push({"value": null, "label": "-全部-"});
                    //
                    allocFormStateList.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.value;
                        queryItem.label = item.text;
                        dataList.push(queryItem);
                    });
                }
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {dataList: dataList};
                let fieldInfo = {};
                fieldInfo["state"] = data;
                query_model_ctrl.updateFields(fieldInfo);
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'state': function (row, colName, colValue, rowIndex) {
                        return self.allocFormStateMap[row.state];
                    },
                    'orderNo': function (row, colName, colValue, rowIndex) {
                        return '<span><a class="table-cell-link" >' + row.orderNo + '</a></span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        //关闭-手工配货(任务) 2021-01-28 @cui  合同商品订单的配货信息，现在应该把撤回、发送、删除功能先注释掉，因为手工配货已经去掉了；
//                        if(self.checkActionPerm('delete') && row.state == 0) {
//                            btnList.push({
//                                name: 'delete',
//                                text: '删除'
//                            });
//                        }
                        if(self.checkActionPerm('modify') && row.state == 0 && !row.orderFlag) {
                            btnList.push({
                                name: 'modify',
                                text: '修改'
                            });
                        }
                        if(self.checkActionPerm('show')) {
                            btnList.push({
                                name: 'show',
                                text: '查看'
                            });
                        }
//                        if(self.checkActionPerm('send') && row.state == 0) {
//                            btnList.push({
//                                name: 'send',
//                                text: '发送'
//                            });
//                        }
//                        if(self.checkActionPerm('cancel') && row.state == 1) {
//                            btnList.push({
//                                name: 'cancel',
//                                text: '撤回'
//                            });
//                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'orderNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.showGoodsOrder(row.orderId);
                    },
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'delete') {
                            self.deleteAllocForm(row);
                        } else if(btnName == 'modify') {
                            self.saveAllocFrom(row.id);
                        } else if(btnName == 'show') {
                            self.viewAllocFrom(row);
                        } else if(btnName == 'send') {
                            self.sendAllocForm(row);
                        } else if(btnName == 'cancel') {
                            self.doCancelAllocForm(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            handleClick: function () {
                let orderFlag = this.orderFlag;
                this.pageNumber = 1;
                if(Utils.isTrue(orderFlag)) {
                    this.resultKey = "swb-order-goods-alloc-form-list-1";
                    //
                } else {
                    this.resultKey = "swb-order-goods-alloc-form-list";
                }
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let fieldInfo = {};
                fieldInfo["state"] = {
                    hidden: Utils.isTrue(orderFlag) ? true : false,
                };
                query_model_ctrl.updateFields(fieldInfo);
                //
                let titleInfo = {};
                titleInfo["title"] = {
                    hidden: Utils.isTrue(orderFlag) ? true : false,
                };
                query_model_ctrl.updateFields(titleInfo);
                //
                let orderNoInfo = {};
                orderNoInfo["orderNo"] = {
                    hidden: Utils.isTrue(orderFlag) ? false : true,
                };
                query_model_ctrl.updateFields(orderNoInfo);
                this.getOrderGoodsAllocFormList();
            },
            queryHandler(queryModel){
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getOrderGoodsAllocFormList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getOrderGoodsAllocFormList();
            },
            getOrderGoodsAllocFormList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.orderFlag = Utils.isTrue(self.orderFlag) || false;
                filterItems.buyerShopId = self.selectComId;
                filterItems.comLevel = self.comLevel;
                filterItems.includeSubComs = self.includeSubComs;
                filterItems.mgmtSmlAreaId = self.mgmtSmlAreaId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                goodsOrderApi.getOrderGoodsAllocFormList(postData, function (result) {
                    theLoad.close();
                    if(result.type == "info") {
                        let data = result.data;
                        self.renderTable(data.rows, data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkComCatChange: function (eventData) {
                if(Utils.isTrue(eventData.mgmtFlag)) {
                    let scopeEntity = this.scopeEntity;
                    this.mgmtSmlAreaId = eventData.id;
                    this.comLevel = scopeEntity.comLevel;
                    this.selectComId = scopeEntity.comId;
                    this.includeSubComs = true;
                } else {
                    this.mgmtSmlAreaId = null;
                    this.comLevel = eventData.level;
                    this.selectComId = eventData.id;
                    this.includeSubComs = eventData.includeSubComs;
                }
                this.getOrderGoodsAllocFormList();
            },
            // 新增
            saveAllocFrom: function (id) {
                let formId = null;
                if(!Utils.isNoB(id)) {
                    formId = id;
                }
                this.$router.push({
                    path: SwbOrderGoodsAllocFormSave.path,
                    query: {
                        formId: formId
                    }
                });
            },
            // 导入配货说明
            showImportElpx: function () {
                openAllocFormFormatExplDlg();
            },
            // 导出配货模板
            downloadAllocFromTemplate: function () {
                showAllocFormTemplateDialog(function (templateData, theDlg) {
                    goodsOrderApi.allocFormTemplateForExport(templateData, function (result) {
                        if(result.type == 'info') {
                            Utils.downloadFile(getAppUrl(result.data));
                            theDlg.close();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 导入配货
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('请选择要上传的文件');
                    return false;
                }
                this.theLoader = MsgBox.loading("正在解析资产文件");
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            onUploadDone: function (result) {
                let self = this;
                self.theLoader.hide();
                if(result.type === 'info') {
                    let files = result.data.files;
                    self.file = files[0];
                    // 文件是否按模版导入
                    let errorMsgList = self.file.extra.errorMsgList;
                    if(!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                        MsgBox.warning(errorMsgList.join("<br/>"));
                        return;
                    }
                    // 验证此文件中导入的内容
                    self.toOpenAllocFormImpCheckDlg(self.file);
                } else {
                    MsgBox.warning(result.message);
                }
            },
            // 导入内容校验
            toOpenAllocFormImpCheckDlg (fileObj) {
                let self = this;
                // 先调用一次检验方法
                let allocFormImpDto = {
                    originalFileName: fileObj.extra.originalFileName,
                    impInfoList: fileObj.extra.impInfoList || [],
                    dumyBrandNames: []
                };
                // 大于500条目不能执行统一检查
                if(allocFormImpDto.impInfoList.length > 30) {
                    Toast.show("最多可导入30条！");
                    return false;
                } else {
                    for(let i = 0; i < allocFormImpDto.impInfoList.length; i++) {
                        let impInfo = allocFormImpDto.impInfoList[i];
                        if(Utils.isNoB(impInfo.desireArriveDate)) {
                            Toast.show("请输入要求到货日期！");
                            return false;
                        }
                        if(impInfo.desireArriveDate != null) {
                            impInfo.desireArriveDate = new Date(impInfo.desireArriveDate).format("yyyy-MM-dd");
                        }
                    }
                    //
                    let theLoading = MsgBox.loading("正在检查导入数据");
                    goodsOrderApi.validateOrderGoodsAllocFormImpTemplate(allocFormImpDto, function (result) {
                        theLoading.close();
                        let impDto = result.data;
                        for(let i = 0; i < impDto.impInfoList.length; i++) {
                            let impInfo = impDto.impInfoList[i];
                            if(impInfo.desireArriveDate != null) {
                                impInfo.desireArriveDate = new Date(impInfo.desireArriveDate).format("yyyy-MM-dd");
                            }
                        }
                        let fileObj = {
                            extra: {
                                originalFileName: impDto.originalFileName,
                                impInfoList: impDto.impInfoList
                            }
                        };
                        openAllocFormImpCheckDlg(fileObj, function (result, theDlg) {
                            let success = result.success || false;
                            if(Utils.isTrue(success)) {
                                Toast.show(result.message);
                                theDlg.close();
                                // 导入后回调的方法,刷新列表
                                self.getOrderGoodsAllocFormList();
                            } else {
                                Toast.show(result.message);
                                return false;
                            }
                        });
                    });
                }
            },
            // 查看订单
            showGoodsOrder: function (orderId) {
                this.$router.push({
                    path: SwbShowGoodsOrder.path,
                    query: {
                        goodsOrderId: orderId,
                        parentPath: this.$route.path
                    }
                });
            },
            viewAllocFrom: function (row) {
                Vue.$showDialog({
                    title: "配货单-详情",
                    width: -400,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<swb-order-goods-alloc-form-detail :formId="id"></swb-order-goods-alloc-form-detail>',
                    data: {
                        id: row.id,
                    }
                });
            },

            // 删除
            deleteAllocForm: function (row) {
                let self = this;
                self.$confirm('确定要删除当前配货单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = row.id;
                    let theLoad = MsgBox.loading();
                    goodsOrderApi.doDeleteOrderGoodsAllocForm(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success('删除成功!');
                            self.getOrderGoodsAllocFormList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 删除
            sendAllocForm: function (row) {
                let self = this;
                self.$confirm('确定要发送当前配货单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.formId = row.id;
                    let theLoad = MsgBox.loading();
                    goodsOrderApi.doUpdateOrderGoodsAllocFormState(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success('发送成功!');
                            self.getOrderGoodsAllocFormList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            doCancelAllocForm: function (row) {
                let self = this;
                self.$confirm('确定要撤回当前配货单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.formId = row.id;
                    let theLoad = MsgBox.loading();
                    goodsOrderApi.doCancelOrderGoodsAllocForm(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success('撤回成功!');
                            self.getOrderGoodsAllocFormList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocFormList.vue